import Header from '../components/Header';
import Books2 from '../components/Books2';
// import HIW from '../components/HIWs';
// import NFTsGrid from '../components/Nfts';
import Footer from '../components/Footer';


export default function Bookpage2() {
  return (
    <div className=" text-white bg-darkBlue ">
      <Header page={"create"} />
      <Books2 />
      <Footer />

    </div>
  );
}
